import type { FilterConditionType } from '@/types/FilterConditionTypes';

/**
 * Transformuje frontend filtry na backend formát
 * Frontend: [{field: "name", operator: "like", value: "test"}]
 * Backend: {"name": [{"op": "like", "value": "test"}]}
 *
 * POZNÁMKA: Operator už je `code` (ne `symbol`) díky BFilterConditions
 */
export function transformFiltersForBackend(
    filters: FilterConditionType[],
): Record<string, Array<{ op: string; value: string | string[] | null }>> {
    const backendFilters: Record<string, Array<{ op: string; value: string | string[] | null }>> = {};

    for (const filter of filters) {
        const { field, operator, value } = filter;

        // Operator je už `code` (like, eq), ne `symbol` (contains, =)
        // Žádné mapování není potřeba!

        // Transformuj hodnotu pouze pro null operátory
        // Multi-value operators (in/nin) keep their array value.
        let transformedValue: string | string[] | null = value;
        if (operator === 'null' || operator === 'nnull') {
            transformedValue = null;
        }

        // Inicializuj pole pro field pokud neexistuje
        if (!backendFilters[field]) {
            backendFilters[field] = [];
        }

        // Přidej podmínku
        backendFilters[field].push({
            op: operator, // Už je code!
            value: transformedValue,
        });
    }

    return backendFilters;
}
